import React, { useState } from 'react';
import CpfContributionReportView from './CpfContributionReportView';
import CpfMissingPranReportView from './CpfMissingPranReportView';
import { FileText, Users } from 'lucide-react';

const CpfReportView = ({
  initialYear = String(new Date().getFullYear()),
  initialMonth = String(new Date().getMonth() + 1),
  initialDepartment = 'ALL',
  departmentsList = [],
  defaultTab = 'contribution',
}) => {
  const [activeTab, setActiveTab] = useState(defaultTab);

  return (
    <div className="space-y-4">
      {/* Tab Switcher */}
      <div className="print:hidden flex items-center gap-2 border-b border-gray-200 pb-2">
        <button
          onClick={() => setActiveTab('contribution')}
          className={`flex items-center gap-2 px-4 py-2 text-sm font-bold rounded-lg transition-colors ${
            activeTab === 'contribution'
              ? 'bg-teal-600 text-white shadow-sm'
              : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
          }`}
        >
          <FileText className="w-4 h-4" />
          1. CPF Contribution Statement
        </button>
        <button
          onClick={() => setActiveTab('missing-pran')}
          className={`flex items-center gap-2 px-4 py-2 text-sm font-bold rounded-lg transition-colors ${
            activeTab === 'missing-pran'
              ? 'bg-rose-600 text-white shadow-sm'
              : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
          }`}
        >
          <Users className="w-4 h-4" />
          2. Employees Without PRAN & Absent
        </button>
      </div>

      {/* Active Report View */}
      {activeTab === 'contribution' ? (
        <CpfContributionReportView
          initialYear={initialYear}
          initialMonth={initialMonth}
          initialDepartment={initialDepartment}
          departmentsList={departmentsList}
        />
      ) : (
        <CpfMissingPranReportView
          initialYear={initialYear}
          initialMonth={initialMonth}
          initialDepartment={initialDepartment}
          departmentsList={departmentsList}
        />
      )}
    </div>
  );
};

export default CpfReportView;
